import a from"styled-components";import{theme as i}from"../../../theme.js";const p=a.div`
  background-color: ${i.colors.gray[50]};
`,e=a.div`
  width: ${i.maxWidth};
  margin: auto;
  padding: ${i.spacing*20}px 0;
  display: grid;
  grid-template-columns: 290px max-content max-content max-content;
  grid-gap: ${i.spacing*12}px;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.xl}) {
    padding: ${i.spacing*4}px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: ${i.spacing*12}px;
  }
  @media screen and (max-width: ${i.breakpoints.lg}) {
    display: grid;
    grid-gap: ${i.spacing*12}px;
    grid-template-columns: 1fr;
  }
`,n=a.h3`
  font-size: 20px;
  line-height: 30px;
  color: ${i.colors.gray[900]};
  margin: 0;
`,o=a.a`
  text-decoration: unset;
  cursor: pointer;
  color: ${i.colors.gray[900]};
  line-height: 21px;
  font-size: 14px;
  &:hover {
    color: ${i.colors.primary[500]};
  }
`,r=a.p`
  line-height: 21px;
  font-size: 14px;
  color: ${i.colors.gray[900]};
  margin: 0;
`,t=a.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  &.large-gap {
    gap: ${i.spacing*12}px;
  }
  @media screen and (max-width: ${i.breakpoints.xl}) {
    flex-grow: 1;
  }
`,d=a.div`
  background-color: ${i.colors.primary[500]};
  > div {
    width: ${i.maxWidth};
    margin: auto;
    display: grid;
    grid-template-columns: 160px 1fr;
    align-items: center;
    grid-column-gap: ${i.spacing*20}px;
    padding: ${i.spacing*6}px 0;
    box-sizing: border-box;
    span {
      font-size: 16px;
      line-height: 24px;
      color: ${i.colors.shades[0]};
    }
    .logo {
      display: flex;
      flex-direction: column;
      gap: ${i.spacing*2}px;
      a {
        height: 40px;
      }
      svg {
        width: 160px;
        height: 40px;
      }
    }
  }
  @media screen and (max-width: ${i.breakpoints.xl}) {
    > div {
      padding: ${i.spacing*6}px ${i.spacing*4}px;
      width: 100%;
    }
  }
  @media screen and (max-width: ${i.breakpoints.md}) {
    > div {
      grid-template-columns: 1fr;
      grid-row-gap: ${i.spacing*6}px;
    }
  }
`,g=a.div`
  display: flex;
  gap: ${i.spacing*2}px;
  > a {
    text-decoration: unset;
    color: inherit;
    width: 36px;
    height: 36px;
    > svg {
      width: 36px;
      height: 36px;
    }
  }
`;export{p as Container,r as Description,o as Link,t as ListContainer,n as SectionTitle,g as SocialsContainer,d as TermsContainer,e as Wrapper};
